"use strict";
/*!
 *
 * app.js
 *
 */
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
// import 'polyfill';
global.Promise = require('es6-promise').Promise;
require("picturefill");
/*** node_modules **/
require("jquery.easing");
require("slick-carousel");
/*** ./modules **/
var hasher_1 = __importDefault(require("hasher"));
// import Linker from 'linker';
var slide_scroll_1 = __importDefault(require("slide-scroll"));
var tel_handler_1 = __importDefault(require("tel-handler"));
require("@fancyapps/fancybox");
require("fancy-defaults");
var object_fit_images_1 = __importDefault(require("object-fit-images"));
var widget_1 = __importDefault(require("widget"));
var menu_1 = __importDefault(require("menu"));
var top_1 = require("top");
var products_1 = __importDefault(require("products"));
// import 'accordion';
require("wiper");
var drop_1 = __importDefault(require("drop"));
var scroll_action_1 = __importDefault(require("scroll-action"));
var tab_1 = __importDefault(require("tab"));
require("parallax");
require("fit-height");
// import videojs from 'video.js/dist/video.js';
var match_1 = __importDefault(require("match"));
var wiper_search_1 = __importDefault(require("wiper-search"));
var wiper_card_1 = __importDefault(require("wiper-card"));
var shop_1 = require("shop");
var local_1 = __importDefault(require("local"));
hasher_1.default();
$(function () {
    new widget_1.default();
    new menu_1.default();
    tel_handler_1.default();
    slide_scroll_1.default({
        easing: 'easeOutExpo',
        speed: 700,
        not: '.sw-NotScroll, .sw-Modal, .wpr-Nav_Link'
    });
    new local_1.default();
    new top_1.Hero();
    new drop_1.default();
    new wiper_search_1.default();
    new top_1.Top();
    new products_1.default();
    new match_1.default();
    new scroll_action_1.default();
    new tab_1.default();
    new wiper_card_1.default();
    new shop_1.ShopSearch();
    new shop_1.ShopMap();
    $('.sw-Modal').not('.-ajax').on('click', function (e) {
        e.preventDefault();
        var src = $(e.currentTarget).attr('href');
        var opts = {};
        if ($(e.currentTarget).is('.-sm')) {
            opts = {
                baseClass: 'fancybox-small'
            };
        }
        ;
        if ($(e.currentTarget).is('.-xs')) {
            opts = {
                baseClass: 'fancybox-x-small'
            };
        }
        ;
        $.fancybox.open({
            src: src
        }, opts);
    });
    $('.sw-Modal.-ajax').on('click', function (e) {
        e.preventDefault();
        var src = $(e.currentTarget).attr('href');
        $.fancybox.open({
            src: src,
            type: 'ajax'
        });
    });
    $('.c-Parallax').parallax();
    object_fit_images_1.default('img.sw-ObjectFit', { watchMQ: true });
    // let videoOptions: any = {
    // 	controls: true,
    // 	autoplay: false,
    // 	preload: 'auto',
    // 	fluid: true,
    // 	controlBar: {
    // 		pictureInPictureToggle: false
    // 	}
    // };
    // $('.video-js').each((i: number, elem: HTMLElement) => {
    // 	let ratio = $(elem).data('ratio') ? $(elem).data('ratio') : '16:9';
    // 	videoOptions.aspectRatio = ratio;
    // 	videojs(elem, videoOptions, function() {
    // 		$(window).trigger('resize');
    // 	});
    // });
    var $tech = $('.c-Grid').filter(function (i, elem) {
        return $(elem).find('.c-Frame_Label').length > 0;
    });
    $tech.each(function (i, elem) {
        $(elem).fitHeight({
            target: '.c-Frame_Label',
            column: 2,
            responsive: {
                'phone': 1,
                'tablet': 2,
                'desktop': 2,
                'largeDesktop': 2
            }
        });
    });
    if ($('.video-js').length) {
        var s = document.getElementsByTagName('script')[0];
        var vs = document.createElement('script');
        vs.src = '/assets/js/video.js';
        vs.type = 'text/javascript';
        vs.async = true;
        s.parentNode.insertBefore(vs, s);
    }
    ;
    if ($('.blv-Slider').length) {
        $('.blv-Slider').slick({
            dots: true,
            arrows: false,
            autoplay: true,
            autoplaySpeed: 3000,
            slidesToShow: 1
        });
    }
    ;
    $(window).trigger('scroll');
});
